/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_ApprovedInputs */



/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Editor_Filter_ApprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_approved = /** @type {((inputs?: Editor_Filter_ApprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_ApprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuvé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已批准")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमोदित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovado")
	return /** @type {LocalizedString} */ ("Approved")
});